export const CALENDAR = '/calendar/' as const
export const CALENDAR_EVENT = `${CALENDAR}event/` as const
export const CALENDAR_EVENT_STUDENT = `${CALENDAR_EVENT}student/` as const
export const CALENDAR_EVENT_TEACHING_WEEKS = `${CALENDAR_EVENT}teaching-weeks` as const
export const CALENDAR_EVENT_ALL = `${CALENDAR}event/all` as const
